if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[]},
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}